import * as React from 'react'
import { IRiderLocationObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import LocationListItem from './LocationtListItem'

interface ILocationListProps {
  locations: IRiderLocationObject[]
}

class LocationList extends React.Component<ILocationListProps> {
  constructor(props: ILocationListProps) {
    super(props)
  }

  public render() {
    return (
      <div className='flex'>
        <div style={{ flex: 2 }}>
          <div className='flex'>
            <div className='col-1'>&nbsp;</div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.nameLabel}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.phoneNumber}</span>
            </div>
            <div className='col-4'>
              <span className='h5 font-grey2'>{UIMessages.common.address}</span>
            </div>
            <div className='col-3'>
              <span className='h5 font-grey2'>{UIMessages.common.note}</span>
            </div>
          </div>
          <div className='bt-light-grey4 mt1'>&nbsp;</div>
          {!!this.props.locations.length ? (
            this.props.locations.map((item, i) => <LocationListItem key={`tmli-${i}`} location={item} />)
          ) : (
            <i className='fs-16 font-light-grey text-center'>
              <p>{UIMessages.rider.location.noLocation}</p>
            </i>
          )}
        </div>
      </div>
    )
  }
}

export default LocationList



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/location/LocationList.tsx